﻿import React from 'react';
import {Grid, GridOwnProps} from "@mui/material";

const SecurSpaceReportPaginationContainer = (props: GridOwnProps) => {
  return <Grid container justifyContent={'end'} {...props} />
}

export { SecurSpaceReportPaginationContainer };
